/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateColTransactionStoreErrorCmd } from '../../models/create-col-transaction-store-error-cmd';
import { ValidationError } from '../../models/validation-error';

export interface InsertColTransactionStoreErrors$Params {
      body?: CreateColTransactionStoreErrorCmd
}

export function insertColTransactionStoreErrors(http: HttpClient, rootUrl: string, params?: InsertColTransactionStoreErrors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ValidationError>>> {
  const rb = new RequestBuilder(rootUrl, insertColTransactionStoreErrors.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ValidationError>>;
    })
  );
}

insertColTransactionStoreErrors.PATH = '/api/collector/transaction_errors';
